<template>
    <div>
        <div class="goods-list-wrapper">
            <transition name="fade">
                <div
                    class="zhezhao"
                    v-show="activeIndex"
                    @click="activeIndex = 0"
                ></div>
            </transition>
            <div class="sort-nav-wrapper">
                <div class="nav" v-cloak>
                    <div
                        class="each-nav"
                        @click="activeIndex = 1"
                        :class="{ active: activeIndex === 1 }"
                    >
                        {{ currentItem[0].name }}
                        <img :src="downIconSrc" v-show="activeIndex !== 1" />
                        <img
                            :src="downIconActiveSrc"
                            v-show="activeIndex == 1"
                        />
                    </div>

                    <div
                        class="each-nav"
                        @click="activeIndex = 2"
                        :class="{ active: activeIndex === 2 }"
                    >
                        {{ currentItem[1].name }}
                        <img :src="downIconSrc" v-show="activeIndex !== 2" />
                        <img
                            :src="downIconActiveSrc"
                            v-show="activeIndex === 2"
                        />
                    </div>
                </div>

                <div class="nav-list" v-cloak>
                    <div class="each-list" v-show="activeIndex === 1">
                        <div
                            class="list"
                            v-for="(item, index) in sortType"
                            @click="getSortedGoodsDataFromPage(0, item)"
                            :class="{ active: currentItem[0].id === item.id }"
                            :key="index"
                        >
                            {{ item.name }}
                            <img
                                v-show="currentItem[0].id === item.id"
                                :src="selectedSrc"
                                class="select-icon"
                            />
                        </div>
                    </div>

                    <div class="each-list" v-show="activeIndex === 2">
                        <div
                            class="list"
                            v-for="(item, index) in sort2Type"
                            @click="getSortedGoodsDataFromPage(1, item)"
                            :class="{ active: currentItem[1].id === item.id }"
                            :key="index"
                        >
                            {{ item.name }}
                            <img
                                v-show="currentItem[1].id === item.id"
                                :src="selectedSrc"
                                class="select-icon"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <van-pull-refresh
                v-model="isLoading"
                @refresh="pullDownRefresh"
                class="pull-refresh-wrapper"
            >
                <img slot="loading" :src="loadingSrc" class="boms-loading-sm" />
                <img slot="normal" :src="loadingSrc" class="boms-loading-sm" />
                <img slot="pulling" :src="loadingSrc" class="boms-loading-sm" />
                <img slot="loosing" :src="loadingSrc" class="boms-loading-sm" />
                <van-list
                    v-model="pullUpLoading"
                    :finished="isMaxData"
                    @load="pullUpLoadData"
                    :immediate-check="false"
                    class="goods-wra"
                >
                    <list-of-goods
                        v-for="item of goodsListData"
                        :key="item.id"
                        :item="item"
                        @click.native="redirectToGoodsDetail(item.id)"
                    ></list-of-goods>
                </van-list>
            </van-pull-refresh>
        </div>
        <div class="cart-wrapper" @click="redirectToCart">
            <div class="img-wra" v-if="cartTotalNumber">
                <div class="badge" v-text="cartTotalNumber"></div>
            </div>
        </div>
        <page-guide></page-guide>
    </div>
</template>

<script>
import { _auth } from "@/js/auth";
import ListOfGoods from "@/components/ListOfGoods";
import PageGuide from "@/components/common/PageGuide";
export default {
    name: "GoodsList",
    components: { ListOfGoods, PageGuide },
    props: {
        // layouts: String,
        // layoutType: String,
    },
    data() {
        return {
            isLoading: false,
            pullUpLoading: false,
            isMaxData: false,
            currentPage: 0,
            goodsListData: [],
            numberInEachPage: 10,
            activeIndex: 0, //0无1全部分类2默认排序
            sortType: [], //全部分类由后台配置（第一个是默认的）
            sort2Type: [
                { id: 0, name: "默认排序" },
                { id: 1, name: "高价优先" },
                { id: 2, name: "低价优先" },
                { id: 3, name: "高评分优先" },
                { id: 4, name: "低评分优先" },
            ],
            currentItem: [
                { id: 0, name: "全部分类" },
                { id: 0, name: "默认排序" },
            ],
            cartTotalNumber: 0,
            cateId: 0,
            isWXSharePage: true,
            downIconSrc: "",
            downIconActiveSrc: "",
            selectedSrc: "",
            loadingSrc: "",
            token: sessionStorage.getItem("token") || "",
        };
    },
    computed: {},
    watch: {},
    created() {},
    activated() {
        this.isWXSharePage = true;
        this.pullDownRefresh();
        this.getCartNumber();
    },
    deactivated() {
        this.isWXSharePage = false;
    },
    mounted() {
        this.downIconSrc = API.ossUrl + "goods/png/down-icon.png";
        this.downIconActiveSrc = API.ossUrl + "goods/png/down-icon-active.png";
        this.selectedSrc = API.ossUrl + "goods/png/selected.png";
        this.loadingSrc = API.ossUrl + "yyq/loading.gif";
    },
    destroyed() {},
    methods: {
        getSortedGoodsDataFromPage(index, item) {
            this.$set(this.currentItem, index, item);
            this.activeIndex = 0;
            this.pullDownRefresh();
        },
        getGoodsDataFromPage(number = 1) {
            let type1 = this.currentItem[0].id;
            let type2 = this.currentItem[1].id;
            return this.$axios.get(
                `${API.goods.list}/${type1}/${type2}/${number}/${this.numberInEachPage}?typeId=2`
            );
        },
        //下拉刷新
        pullDownRefresh() {
            let vm = this;
            this.getGoodsDataFromPage(1)
                .then(({ data }) => {
                    if (data.code == 200) {
                        let res = data.data;
                        let sortType = [{ id: 0, name: "全部分类" }];
                        for (const key in res.cate) {
                            const value = res.cate[key];
                            sortType.push({
                                id: key,
                                name: value,
                            });
                        }
                        vm.sortType = sortType;
                        vm.goodsListData = res.list;
                        vm.isLoading = false;
                        vm.currentPage = 1;
                        vm.isMaxData = res.pageNo >= res.pageCount;
                        // vm.$nextTick(vm.hiddenTag);
                        //初始化微信分享
                        if (
                            this.isWXSharePage &&
                            sessionStorage.getItem("title") !==
                                `${API.projectName}-${vm.$route.meta.title}`
                        ) {
                            this.isWXSharePage = false;
                            window.global.getConfig({
                                title: `${API.projectName}-${vm.$route.meta.title}`,
                                link: `${window.location.origin}?shareto=${vm.$route.name}`,
                                imgUrl: `${
                                    vm.goodsListData[0]
                                        ? vm.goodsListData[0].thumbimg +
                                          "?x-oss-process=image/resize,m_fill,h_256,w_256"
                                        : ""
                                }`,
                                desc: ``,
                            });
                        }
                    } else {
                        vm.$toast(data.msg);
                    }
                })
                .catch((err) => console.log(err));
        },
        //上拉加载
        pullUpLoadData(number) {
            let vm = this;
            if (vm.currentPage == 0) return (vm.pullUpLoading = false);
            this.getGoodsDataFromPage(vm.currentPage + 1)
                .then(({ data }) => {
                    if (data.code == 200) {
                        let res = data.data;
                        vm.goodsListData = vm.goodsListData.concat(res.list);
                        vm.pullUpLoading = false;
                        vm.currentPage = Number(res.pageNo);
                        vm.isMaxData = res.pageNo >= res.pageCount;
                        vm.$nextTick(vm.hiddenTag);
                    } else {
                        vm.$toast(data.msg);
                    }
                })
                .catch((err) => console.log(err));
        },
        redirectToGoodsDetail(goodsId) {
            this.$router.push({ name: "goodsDetail", params: { goodsId } });
        },
        hiddenTag() {
            let tagArray = [...document.querySelectorAll(".tag")];
            let cw = document.body.clientWidth - 15;
            tagArray.forEach((element) => {
                if (element.getBoundingClientRect().right > cw) {
                    element.style.visibility = "hidden";
                }
            });
        },
        redirectToCart() {
            this.$router.push({ name: "goodsCart" });
        },
        getCartNumber() {
            this.$axios
                .get(
                    `${window.API.goods.listCart}?token=${
                        sessionStorage.token || ""
                    }`
                )
                .then(({ data }) => {
                    if (data.code == 200) {
                        this.cartTotalNumber = data.data.filter((e) => {
                            return e.isEnabled != 0;
                        }).length;
                    }
                });
        },
    },
};
</script>


<style scoped lang="scss">
.goods-list-wrapper /deep/ {
    min-height: 100%;
    display: flex;
    .van-pull-refresh {
        width: 100%;
        flex: 1;
    }
    .zhezhao {
        position: fixed;
        background: rgba(0, 0, 0, 0.3);
        width: 100%;
        height: 100vh;
        z-index: 1000;
    }
    .sort-nav-wrapper {
        z-index: 1005;
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        .nav {
            height: 1.28rem;
            font-size: 16px;
            background: $white;
            display: flex;
            font-weight: 500;
            // line-height:44px;
            color: #707070;
            font-family: PingFang SC;
            .each-nav {
                width: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-wrap: nowrap;
                &.active {
                    color: $orange;
                }
                img {
                    width: 0.24rem;
                    height: 0.133333rem;
                    margin-left: 0.093333rem;
                }
            }
        }
        .nav-list {
            @include border1px(border-top, #ebebeb);
            overflow-y: scroll;
            max-height: 13rem;
            padding-left: 0.333333rem;
            background: $white;
            .each-list {
                &:last-child {
                    border-bottom: 0;
                }
                .list {
                    padding-left: 0.333333rem;
                    padding-right: 0.506667rem;
                    color: #404040;
                    height: 1.173333rem;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 14px;
                    @include border1px(border-bottom, #ebebeb);
                    &.active {
                        color: $orange;
                    }
                    .select-icon {
                        width: 0.506667rem;
                        height: 0.506667rem;
                    }
                }
            }
        }
        .each-list::-webkit-scrollbar {
            display: none;
        }
    }
    .van-list__loading {
        margin: 0 auto;
    }
    .pull-refresh-wrapper {
        // width: 10rem;
        margin-top: 1.2rem;
        position: relative;
    }
    .goods-wra {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 0.64rem 0.533333rem 0;
    }
}
.cart-wrapper {
    position: fixed;
    bottom: 1.44rem;
    right: 0.666667rem;
    z-index: 100;
    width: 1.226667rem;
    height: 1.226667rem;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    background: #ffffff
        url("http://oss.ygqhgw.com/assets/goods/png/cart-icon.png") 0.12rem
        0.36rem no-repeat;
    background-size: 0.746667rem 0.626667rem;
    .img-wra {
        position: absolute;
        width: 0.373333rem;
        height: 0.373333rem;
        left: 0.733333rem;
        bottom: 0.6rem;
        color: $white;
        background: $orange;
        border-radius: 50%;
        .badge {
            font-size: 20px;
            text-align: center;
            line-height: 0.373333rem;
            transform: scale(0.5);
        }
    }
}
</style>

